const policy = 'https://demo-portal.coverplus.io/services/policy';

const endpoints = { policy };
export default endpoints;

